<div
  #canvasEl
  class="canvas"
  [class.canvas-panning]="isPanning()"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerCancel()"
  (pointerdown)="onBackgroundPointerDown($event)"
>
  <div
    class="canvas-content"
    [style.width.px]="contentSize().width"
    [style.height.px]="contentSize().height"
  >
  <svg class="canvas-edges">
    <defs>
      <marker
        id="wf-arrow"
        viewBox="0 0 10 10"
        refX="9"
        refY="5"
        markerWidth="7"
        markerHeight="7"
        orient="auto-start-reverse"
      >
        <path d="M 0 0 L 10 5 L 0 10 z" />
      </marker>
    </defs>
    @for (e of edges(); track e.key) {
      <g class="edge-group" [class.edge-selected]="selectedEdgeKey() === e.key">
        <line
          [attr.x1]="e.x1"
          [attr.y1]="e.y1"
          [attr.x2]="e.x2"
          [attr.y2]="e.y2"
          class="edge-hit"
          (pointerdown)="onEdgePointerDown($event, e)"
        />
        <line
          [attr.x1]="e.x1"
          [attr.y1]="e.y1"
          [attr.x2]="e.x2"
          [attr.y2]="e.y2"
          class="edge"
          [class.edge-false]="e.branch === 'false'"
          marker-end="url(#wf-arrow)"
        />
      </g>
    }
    @if (pendingEdge(); as pe) {
      <line
        [attr.x1]="pe.x1"
        [attr.y1]="pe.y1"
        [attr.x2]="pe.x2"
        [attr.y2]="pe.y2"
        class="edge edge-pending"
        [class.edge-false]="pe.branch === 'false'"
        marker-end="url(#wf-arrow)"
      />
    }
  </svg>

  @for (view of nodeViews(); track view.node.id) {
    <div
      #nodeEl
      class="node"
      [attr.data-id]="view.node.id"
      [class.node-selected]="isSelected(view.node.id)"
      [class.node-drop-target]="hoverTarget() === view.node.id"
      [class.node-trigger]="view.node.type === 'trigger'"
      [class.node-action]="view.node.type === 'action'"
      [class.node-rule]="view.node.type === 'rule'"
      [class.node-terminator]="view.node.type === 'terminator'"
      [style.left.px]="view.x"
      [style.top.px]="view.y"
      (pointerdown)="onNodePointerDown($event, view.node)"
    >
      <span class="node-type">{{ view.typeLabel }}</span>
      <span class="node-name">{{ view.node.name || 'Untitled' }}</span>

      @if (view.hasOutput) {
        <button
          type="button"
          class="node-handle node-handle-true"
          (pointerdown)="onHandlePointerDown($event, view.node, 'true')"
          [attr.aria-label]="view.isCondition ? 'Drag to connect true branch' : 'Drag to connect'"
        ></button>
      }
      @if (view.isCondition) {
        <button
          type="button"
          class="node-handle node-handle-false"
          (pointerdown)="onHandlePointerDown($event, view.node, 'false')"
          aria-label="Drag to connect false branch"
        ></button>
      }
    </div>
  }
  </div>

  @if (nodeViews().length === 0) {
    <div class="canvas-empty">
      <span class="material-symbols-outlined">account_tree</span>
      <p>Add a node from the palette to start building your workflow.</p>
    </div>
  }
</div>
